export default function PointsOverview({
  pointsData,
  finalGameChoice,
  gameMultiplier,
  sendMessage,
  playerId,
  waitingForPlayers
}) {
  const continueGame = () => {
    sendMessage({ type: "ready_for_next_round", playerId })
    console.log(waitingForPlayers);
  };

  return (
    <div>
        <div className="points-overview">
          <h2>Punkte Übersicht</h2>

          <div>Laufende: {Math.abs(pointsData?.laufende)}</div>
          <div>Schneider: {Math.abs(pointsData?.schneider)}</div>
          <div>Schwarz: {Math.abs(pointsData?.schwarz)}</div>

          <div>
            Kosten des Spiels {finalGameChoice}:{" "}
            {Math.abs(pointsData?.base_points) / gameMultiplier}
            {gameMultiplier > 1 && <div>Multiplikator: {gameMultiplier}</div>}
          </div>

          <div className="hand">
            <table border="1" className="result-table">
              <thead>
                {pointsData?.player_results &&
                  pointsData?.player_results.map((item, index) => (
                    <tr key={index}>
                      {Object.keys(item).map((key) => (
                        <th key={key}>{item[key]}</th>
                      ))}
                    </tr>
                  ))}
              </thead>

              <tbody>
                <tr className="table-total">
                  {pointsData?.total_results &&
                    pointsData?.total_results.length > 0 &&
                    Object.keys(pointsData?.total_results[0]).map((key) => (
                      <th key={key}>{key}</th>
                    ))}
                </tr>

                {pointsData?.total_results &&
                  pointsData?.total_results.map((item, index) => (
                    <tr key={index}>
                      {Object.keys(item).map((key) => (
                        <td key={key}>{item[key]}</td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
            <button onClick={continueGame} title="Continue" id="btn-continue">
              Weiter
            </button>
            <div>Warte auf Spieler: {waitingForPlayers?.join(", ")}</div>
          </div>
        </div>
      </div>
  );
}
